import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import axiosClient from "axiosClient";
import axiosClientHyperWolf from 'axiosClient/indexHyperWolf';
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))
import { HEMP, HYPERWOLF, STILO } from 'utilities/constants';
export async function getBlogListAPI(data) {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/blogs/listing?${getQueryString(data)}&userType=admin`);
}

export const getBlogList = createAsyncThunk(
    'blogs/getBlogList',
    async (data, { rejectWithValue }) => {
        try {
            const res = await getBlogListAPI(data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function createBlogAPI(data) {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).post('/api/v1/admin/blogs', data);
}

export const createBlog = createAsyncThunk(
    'blogs/createBlog',
    async (data, { rejectWithValue }) => {
        try {
            const res = await createBlogAPI(data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function updateBlogAPI(id, data) {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/blogs/${id}`, data);
}

export const updateBlog = createAsyncThunk(
    'blogs/updateBlog',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await updateBlogAPI(id, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function findBlogByIdAPI(blogId) {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/blogs/${blogId}?userType=admin`);
}

export const findBlogById = createAsyncThunk(
    'blogs/findBlogById',
    async (blogId, { rejectWithValue }) => {
        try {
            const res = await findBlogByIdAPI(blogId);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);


export async function createBlogCategoryAPI(data) {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).post('/api/v1/create/blog/category', data);
}

export const createBlogCategory = createAsyncThunk(
    'blogs/createBlogCategory',
    async (data, { rejectWithValue }) => {
        try {
            const res = await createBlogCategoryAPI(data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function getBlogCategoriesAPI() {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).get('/api/v1/blog/category/listing');
}

export const getBlogCategories = createAsyncThunk(
    'blogs/getBlogCategories',
    async (_, { rejectWithValue }) => {
        try {
            const res = await getBlogCategoriesAPI();
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function deleteBlogCategoryAPI(categoryId) {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/delete/blog/category/${categoryId}`);
}

export const deleteBlogCategory = createAsyncThunk(
    'blogs/deleteBlogCategory',
    async (categoryId, { rejectWithValue }) => {
        try {
            const res = await deleteBlogCategoryAPI(categoryId);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);



export async function createBlogAuthorAPI(data) {
    return axiosClientStilo.post('/api/v1/create/blog/author', data);
}

export const createBlogAuthor = createAsyncThunk(
    'blogs/createBlogAuthor',
    async (data, { rejectWithValue }) => {
        try {
            const res = await createBlogAuthorAPI(data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function getBlogAuthorsAPI() {
    return await axiosClientStilo.get('/api/v1/blog/author/listing');
}

export const getBlogAuthors = createAsyncThunk(
    'blogs/getBlogAuthors',
    async (_, { rejectWithValue }) => {
        try {
            const res = await getBlogAuthorsAPI();
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function deleteBlogAuthorAPI(authorName) {
    return await axiosClientStilo.delete(`/api/v1/delete/blog/author/${authorName}`);
}

export const deleteBlogAuthor = createAsyncThunk(
    'blogs/deleteBlogAuthor',
    async (authorName, { rejectWithValue }) => {
        try {
            const res = await deleteBlogAuthorAPI(authorName);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);


export async function deleteBlogAPI(blogId) {
    return await axiosClientStilo.delete(`/api/v1/blog/delete/${blogId}`);
}

export const deleteBlog = createAsyncThunk(
    'blogs/deleteBlog',
    async (blogId, { rejectWithValue }) => {
        try {
            const res = await deleteBlogAPI(blogId);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);


// Hyperwolf/Hemp Author and Migrate blog
export async function authorListAPI(data) {
    return await axiosClient.get(`/api/v1/admin/author/pagination?${getQueryString(data)}`);
}

export const migrateAuthor = createAsyncThunk(
    'blogs/migrateAuthor',
    async (data, { rejectWithValue }) => {
        console.log("data", data);

        try {
            console.log("data");

            const res = await authorListAPI(data);

            return res;
        } catch (error) {
            console.log("error", error);

            return rejectWithValue(error.response?.data);
        }
    }
);
export async function deleteMigrateAuthorAPI(authorId) {
    return await axiosClient.delete(`/api/v1/admin/author/${authorId}`);
}

export const deleteMigrateAuthor = createAsyncThunk(
    'blogs/deleteMigrateAuthor',
    async (authorId, { rejectWithValue }) => {
        try {
            const res = await deleteMigrateAuthorAPI(authorId);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function createMigrateAuthorAPI(authordata) {
    if (authordata?.authorId) {
        return await axiosClient.put(`/api/v1/admin/author/${authordata?.authorId}`, authordata);
    }
    else {
        return await axiosClient.post(`/api/v1/admin/author`, authordata);
    }
}

export const createMigrateAuthor = createAsyncThunk(
    'blogs/createMigrateAuthor',
    async (authordata, { rejectWithValue }) => {
        try {
            const res = await createMigrateAuthorAPI(authordata);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export async function getDetailMigrateAuthorsAPI(authorId) {
    return await axiosClient.get(`/api/v1/admin/author/${authorId}?userType=admin`);
}

export const getDetailMigrateAuthors = createAsyncThunk(
    'blogs/getDetailMigrateAuthors',
    async (authorId, { rejectWithValue }) => {
        try {
            const res = await getDetailMigrateAuthorsAPI(authorId);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

// Blog Migrate

export async function migrateQuickEditApiHit(data, id) {
    return await (adminsMode === HYPERWOLF ? axiosClientHyperWolf : adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/blogs/quick/update/${id}`, data);
}

export const migrateQuickEditApi = createAsyncThunk(
    'blogs/migrateQuickEditApi',
    async ({ data, id }, { rejectWithValue }) => {
        try {
            const res = await migrateQuickEditApiHit(data, id);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);